import { PageMeta } from "@/components/common/Seo/PageMeta"
import { Author } from "@/components/resources/components/Author"
import { Pagination } from "@/components/resources/components/Pagination"
import { TeaserGrid } from "@/components/resources/components/TeaserGrid"
import type { AuthorArchiveProps } from "@/components/resources/data/archives"

export const AuthorPage = ({ meta, author, posts, pagination }: AuthorArchiveProps) => {
  return (
    <div className="max-w-[1064px] mx-auto px-4 mb-8 md:mb-12 lg:mb-16 pt-8 md:pt-12 lg:pt-16">
      <PageMeta meta={meta} />
      <div className="flex flex-col gap-6">
        <Author {...author} />
        <div className="flex flex-col gap-4">
          <h2 className="text-xl font-medium">Posts by author</h2>
          <TeaserGrid teasers={posts} />
          <Pagination {...pagination} />
        </div>
      </div>
    </div>
  )
}
